import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../components/ui/dialog'
import { Button } from '../components/ui/button'
import { useEffect, useState } from 'react'
import { Endpoints } from '@/remote/endpoints'
import { usePromiseToast } from '../hooks/toast-promisse'
import { useRemoteClientGet } from '@/configs/http-client'
import { UnitsFormData } from '../validators/units-validator'
import { formatCEP, formatCNPJ } from '../utils/formatDocuments'
import { formatPhone } from '../utils/formatPhone'


type DialogProps = {
  id: number
  isOpen: boolean
  closeDialog: () => void
}

export function DialogDetailUnits({ id, isOpen = false, closeDialog }: DialogProps) {
  const { remoteClientGet } = useRemoteClientGet();
  const { triggerToast } = usePromiseToast();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<UnitsFormData>();

  const unitsFields = [
    { label: 'Nome Fantasia', value: data?.nomeFantasia },
    { label: 'Razão Social', value: data?.razaoSocial },
    { label: 'CNPJ', value: formatCNPJ(data?.cnpj) },
    { label: 'Estado', value: data?.endereco?.estado },
    { label: 'Cidade', value: data?.endereco?.cidade },
    { label: 'CEP', value: formatCEP(data?.endereco?.cep) },
    { label: 'Rua', value: data?.endereco?.rua },
    { label: 'Número', value: data?.endereco?.numero },
    { label: 'Complemento', value: data?.endereco?.complemento },
    { label: 'Bairro', value: data?.endereco?.bairro },
    { label: 'Telefone', value: formatPhone(data?.contato?.telefone) },
    { label: 'Email', value: data?.contato?.email },
  ];

  const fetchData = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await remoteClientGet(`${Endpoints.units}/${id}`);
      setData(response?.data?.data);
    } catch (error) {
      setError('Erro ao carregar dados...');
      console.error(error);
      throw error
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      triggerToast(fetchData());
    }
  }, [isOpen, id]);

  const renderField = (field: any, index: number) => (
    field.value ? (
      <p key={index} className="text-gray-400 flex gap-1">
        <strong className="text-acelerafit-gray-dark">{field.label}:</strong>
        {field.value}
      </p>
    ) : null
  );

  return (
    <Dialog open={isOpen}>
      <DialogContent className="sm:max-w-4xl">
        <DialogHeader className="border-acelerafit-gray-dark">
          <DialogTitle className="text-acelerafit-green-300">Unidades</DialogTitle>
          <DialogDescription>Detalhes</DialogDescription>
        </DialogHeader>

        {isLoading && (
          <div className="flex justify-center items-center p-4">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-acelerafit-green-300" />
          </div>
        )}

        {error && (
          <div className="text-red-500 p-4 text-center">
            {error}
          </div>
        )}

        {!isLoading && !error && (
          <div className="grid grid-cols-2 col-span-1 gap-4">
            {unitsFields.map((field, index) => renderField(field, index))}
          </div>
        )}

        <DialogFooter className="sm:justify-end">
          <Button
            onClick={() => closeDialog()}
            className="bg-acelerafit-green-300 shadow-2xl hover:bg-acelerafit-green-300 hover:opacity-85 transition-all"
          >
            Fechar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}